import { BoxV2 } from '@labrav/react-components'
import React from 'react'
import { useStyles } from './MicrosoftCloudSettingsSections.styles'
import { Typography } from '@mui/material'
import { CloudSettingsHelpSections } from '../CloudSettingsHelpSections/CloudSettingsHelpSections'
import { FlyoutCloudSettingsFaqData } from '../FlyoutCloudSettingsFaqData'
import { MicrosoftStepStatusIcon } from '../MicrosoftStepStatusIcon/MicrosoftStepStatusIcon'
import { getStepNumber } from './helpers'

export interface MicrosoftCloudSettingsSectionProps {
  heading: string
  subheading?: string
  children: React.ReactNode
  sectionName: string
  expandBox?: boolean
  isOptional?: boolean
  actions?: JSX.Element
  isInIframe?: boolean
}

export const MicrosoftCloudSettingsSection: React.FC<
  MicrosoftCloudSettingsSectionProps
> = ({
  heading,
  children,
  subheading,
  sectionName,
  expandBox,
  isOptional,
  actions,
  isInIframe,
}) => {
  const { classes: commonClasses } = useStyles()
  return (
    <BoxV2
      data-testid="microsoft-section-box"
      isOptional={isOptional}
      heading={heading}
      headingIcon={
        <>
          <MicrosoftStepStatusIcon sectionName={sectionName} />
          <Typography className={commonClasses.loadingText}>
            STEP {getStepNumber(sectionName, isInIframe)}
          </Typography>
        </>
      }
      subHeading={subheading ? subheading : ''}
      variant={'small'}
      headingVariant={'small'}
      collapsible
      display={{ open: !!expandBox }}
      closedSecondaryActions={true}
      secondaryActions={
        <CloudSettingsHelpSections
          content={
            FlyoutCloudSettingsFaqData[
              sectionName as keyof typeof FlyoutCloudSettingsFaqData
            ]?.content
          }
        />
      }
      actions={actions}
    >
      {children}
    </BoxV2>
  )
}
